import React from "react";
import PropTypes from "prop-types";
import axios from "axios";
import lodash from "lodash";

import Loading from "../../general/Loading";
import Pagination from "../../general/Pagination";
import Header from "./Header";
import Add from "./Add";
import List from "./List";

const PER_PAGE = 20;

class InServices extends React.Component {
  state = {
    currentPage: 1,
    totalPages: 0,
    loading: false,
    status: "current",
    visibleAdd: false,
    filterQ: "",
    filterLocation: "",
    inServices: []
  };

  locations = [...window.Application.currentLocations];

  componentWillMount() {
    this.locations.unshift({ id: "-1" , name: "No Location Specified" });
    this.locations.unshift({ id: "", name: "All Locations" });
    this.handleLoad();
  }

  toggleAdd = () => this.setState({ visibleAdd: !this.state.visibleAdd });

  handleAdded = inService => {
    const inServices = _.orderBy([inService, ...this.state.inServices], ['start_time'], ['desc'])
    this.setState({ visibleAdd: false, inServices });
  }

  handleSearch = value => this.setState({ filterQ: value }, this.handleLoad);
  handleChangeLocation = e => this.setState({ filterLocation: e.target.value }, this.handleLoad);
  handleChangeStatus = e => this.setState({ status: e.target.value }, this.handleLoad);

  handleSignedUp = (id, record) => {
    const { inServices } = this.state;
    const idx = lodash.findIndex(inServices, { id });

    inServices[idx].in_service_users.push(record);

    this.setState({ inServices });
  };

  handleLoad = (page = 1) => {
    if (this.state.loading) { return; }
    this.setState({ loading: true, currentPage: page });

    const { filterQ, filterLocation, status } = this.state;
    const params = [`page=${page}`, `per_page=${PER_PAGE}`, 'method=signed_up?'];

    if (filterQ) {
      params.push(`q=${encodeURIComponent(filterQ)}`);
    }

    if (status) {
      params.push(`status=${status}`);
    }

    if (filterLocation) {
      params.push(`location=${filterLocation}`);
    } else {
      const ids = this.locations.filter(l => l.id).map(l => l.id).join(",");
      params.push(`location=${ids}`);
      params.push("all_locations=1")
    }

    axios.get(`/in_services.json?${params.join("&")}`)
      .then(({ headers, data }) => {
        const totalPages = Math.ceil(parseInt(headers.total) / PER_PAGE);
        this.setState({
          totalPages,
          loading: false,
          inServices: data
        });
      })
      .catch(() => {
        this.setState({ loading: false });
      })
    ;
  };

  goAnotherPage = dir => {
    const { currentPage } = this.state;
    this.handleLoad(currentPage + dir);
  };

  exportData = () => {
    let params = { status: this.state.status };
    
    if (this.state.filterLocation) {
      params['location_id'] = this.state.filterLocation;
    } else {
      const ids = this.locations.filter(l => l.id).map(l => l.id).join(',');
      params['location_id'] = ids;
      params['all_locations'] = 1;
    }

    if (this.state.filterQ) {
      params['q'] = encodeURIComponent(this.state.filterQ)
    }

    axios
      .get("/schedule_in_services_export.json", { params })
      .then(function (response) {
        toastr.info('Your Excel Export will be generated shortly, an email with a link will be sent and the file will be available in your My Downloads.');
      })
      .catch(function (error) {
        console.log(error);
        toastr.error("Unable to export In services at this time");
      });
  }

  render() {
    const { totalPages, currentPage, loading, status, visibleAdd, filterLocation, inServices } = this.state;
    const { isAdmin, currentUserId, instructors, categories } = this.props;
    const filteredLocations = this.locations.filter(location => location.id !== "");

    return (
      <div>
        <h1>In-Services</h1>
        <Header
          isAdmin={isAdmin}
          locations={this.locations}
          location={filterLocation}
          status={status}
          onChangeLocation={this.handleChangeLocation}
          onSearch={this.handleSearch}
          onChangeStatus={this.handleChangeStatus}
          onAdd={this.toggleAdd}
          onExport={this.exportData}
        />
        <Add
          visible={visibleAdd}
          categories={categories}
          locations={filteredLocations}
          defInstructors={instructors}
          onClose={this.toggleAdd}
          onAdded={this.handleAdded}
        />

        {loading && currentPage === 1 ? null : (
          <List
            isAdmin={isAdmin}
            currentUserId={currentUserId}
            data={inServices}
            onSignedUp={this.handleSignedUp}
          />
        )}

        {loading ? <Loading loading={true}/> : null}

        {totalPages > 1 ? (
          <Pagination totalPages={totalPages} page={currentPage} changePage={this.goAnotherPage}/>
        ) : null}
      </div>
    );
  }
}

InServices.propTypes = {
  isAdmin: PropTypes.bool.isRequired,
  currentUserId: PropTypes.number.isRequired,
  categories: PropTypes.array.isRequired,
  instructors: PropTypes.array.isRequired
};

export default InServices;
